// extracted by mini-css-extract-plugin
export default {"section":"CreateCommentModal_section__n+7Wi","createcommentmodal":"CreateCommentModal_createcommentmodal__vlMiX"};